import Vue from 'vue'

const env = {
  apiUrl: process.env.VUE_APP_API_URL,
  cmsUrl: process.env.VUE_APP_CMS_URL,
  googleSigninClientId: process.env.VUE_APP_GOOGLE_SIGNIN_CLIENT_ID,
  facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
  facebookApiVersion: process.env.VUE_APP_FACEBOOK_API_VERSION,
  appleSigninClientId: process.env.VUE_APP_APPLE_SIGNIN_CLIENT_ID,
  appleRedirectUri: process.env.VUE_APP_APPLE_REDIRECT_URI,
  firebaseAppId: process.env.VUE_APP_FIREBASE_APP_ID,
  firebaseProjectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  firebaseApiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  firebaseMessagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
  placesApiKey: process.env.VUE_APP_PLACES_API_KEY,
  stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
}

Vue.prototype.$env = env

export default env
